import React from 'react';

import styles from 'stylesheets/components/loader.module';

export function Loader() {
  return (
    <div className={styles.loader} role='progressbar' aria-label='Loading content'>
      <div className={styles.bar}></div>
      <div className={styles.bar}></div>
      <div className={styles.bar}></div>
      <div className={styles.bar}></div>
      <div className={styles.bar}></div>
    </div>
  );
}
